import { Col, Row } from "antd";
import { get } from "lodash";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineFileUpload } from "react-icons/md";
import Button from "shared/components/Button";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Label from "shared/components/Label";
import { NAME_SPACES } from "shared/locales/constants";
import { ATTACHMENT_TYPES, BANK_ACCOUNT_OWNER_TYPE } from "utils/constants";

const Payer = ({
  values,
  onFileRemove,
  setFieldValue,
  setPercent,
  disabled,
  subscription,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  useEffect(() => {
    setPercent(values);
  }, [disabled]);

  return (
    <div className="subscription-form--wrapper">
      <Form type="vertical" title={SUBSCRIPTION.FORM.PROOF.PAYER}>
        {get(subscription, "payment.payer.owner.type") ===
          BANK_ACCOUNT_OWNER_TYPE.COMPANY && (
          <>
            <Row gutter={[16, 16]}>
              <Col lg={24} xs={24}>
                <div className="subscription-form--group-label">
                  <Label
                    label={SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY.KBIS}
                    icon={<MdOutlineFileUpload size={16} />}
                    required
                  />
                </div>
              </Col>
              <Col lg={24} xs={24}>
                <div className="subscription-form--custom-upload">
                  <Input
                    type="file"
                    variant="uploader"
                    listType="picture"
                    validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                    multiple
                    onUpload={(fileList) => {
                      setFieldValue(
                        `proof.payer.${ATTACHMENT_TYPES.KBIS}`,
                        fileList,
                      );
                      setPercent({
                        ...values,
                        proof: {
                          ...values.proof,
                          payer: {
                            ...get(values, "proof.payer", {}),
                            [ATTACHMENT_TYPES.KBIS]: fileList,
                          },
                        },
                      });
                    }}
                    onFileRemove={onFileRemove}
                    fileList={get(
                      values,
                      `proof.payer.${ATTACHMENT_TYPES.KBIS}`,
                      [],
                    )}
                  >
                    <Row align="center">
                      <Button type="primary--link">
                        {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                      </Button>
                    </Row>
                  </Input>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col lg={24} xs={24}>
                <div className="subscription-form--group-label">
                  <Label
                    label={SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY.CNI}
                    icon={<MdOutlineFileUpload size={16} />}
                    required
                  />
                </div>
              </Col>
              <Col lg={24} xs={24}>
                <div className="subscription-form--custom-upload">
                  <Input
                    type="file"
                    variant="uploader"
                    listType="picture"
                    validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                    multiple
                    onUpload={(fileList) => {
                      setFieldValue(
                        `proof.payer.${ATTACHMENT_TYPES.PAYER_CIN}`,
                        fileList,
                      );
                      setPercent({
                        ...values,
                        proof: {
                          ...values.proof,
                          payer: {
                            ...get(values, "proof.payer", {}),
                            [ATTACHMENT_TYPES.PAYER_CIN]: fileList,
                          },
                        },
                      });
                    }}
                    onFileRemove={onFileRemove}
                    fileList={get(
                      values,
                      `proof.payer.${ATTACHMENT_TYPES.PAYER_CIN}`,
                      [],
                    )}
                  >
                    <Row align="center">
                      <Button type="primary--link">
                        {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                      </Button>
                    </Row>
                  </Input>
                </div>
              </Col>
            </Row>
            <Row gutter={[16, 16]}>
              <Col lg={24} xs={24}>
                <div className="subscription-form--group-label">
                  <Label
                    label={SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY.COMPANY_RIB}
                    icon={<MdOutlineFileUpload size={16} />}
                    required
                  />
                </div>
              </Col>
              <Col lg={24} xs={24}>
                <div className="subscription-form--custom-upload">
                  <Input
                    type="file"
                    variant="uploader"
                    listType="picture"
                    validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                    multiple
                    onUpload={(fileList) => {
                      setFieldValue(
                        `proof.payer.${ATTACHMENT_TYPES.PAYER_RIB}`,
                        fileList,
                      );
                      setPercent({
                        ...values,
                        proof: {
                          ...values.proof,
                          payer: {
                            ...get(values, "proof.payer", {}),
                            [ATTACHMENT_TYPES.PAYER_RIB]: fileList,
                          },
                        },
                      });
                    }}
                    onFileRemove={onFileRemove}
                    fileList={get(
                      values,
                      `proof.payer.${ATTACHMENT_TYPES.PAYER_RIB}`,
                      [],
                    )}
                  >
                    <Row align="center">
                      <Button type="primary--link">
                        {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                      </Button>
                    </Row>
                  </Input>
                </div>
              </Col>
            </Row>
          </>
        )}
        {get(subscription, "payment.payer.owner.type") ===
          BANK_ACCOUNT_OWNER_TYPE.PARTICULAR && (
          <Row gutter={[16, 16]}>
            <Col lg={24} xs={24}>
              <div className="subscription-form--group-label">
                <Label
                  label={SUBSCRIPTION.FORM.PROOF.MUTUAL_MOBILITY.PAYER_RIB}
                  icon={<MdOutlineFileUpload size={16} />}
                  required
                />
              </div>
            </Col>
            <Col lg={24} xs={24}>
              <div className="subscription-form--custom-upload">
                <Input
                  type="file"
                  variant="uploader"
                  listType="picture"
                  validTypes={SUBSCRIPTION.FORM.PROOF.ALLOWED_FILES_TYPE}
                  multiple
                  onUpload={(fileList) => {
                    setFieldValue(
                      `proof.payer.${ATTACHMENT_TYPES.PAYER_RIB}`,
                      fileList,
                    );
                    setPercent({
                      ...values,
                      proof: {
                        ...values.proof,
                        payer: {
                          ...get(values, "proof.payer", {}),
                          [ATTACHMENT_TYPES.PAYER_RIB]: fileList,
                        },
                      },
                    });
                  }}
                  onFileRemove={onFileRemove}
                  fileList={get(
                    values,
                    `proof.payer.${ATTACHMENT_TYPES.PAYER_RIB}`,
                    [],
                  )}
                >
                  <Row align="center">
                    <Button type="primary--link">
                      {SUBSCRIPTION.FORM.PROOF.ACTION.ADD}
                    </Button>
                  </Row>
                </Input>
              </div>
            </Col>
          </Row>
        )}
      </Form>
    </div>
  );
};

export default Payer;
